import React from "react";
import Stack from "@mui/material/Stack";
import { Chip } from "@mui/material";
import { translatorForTheStatusOfStoppingPoints } from "../../view/frete-copy/action/action";
import {
  formatFinancialStatusValue,
  normalizeFinancialStatusValue,
} from "./freight-v2-table-utils";

const FREIGHT_IN_TRANSIT_DESCRIBE = "Em transito";
const STATUS_CHIP_STYLE = { minWidth: "100px", maxWidth: "150px" };

function renderStatusChip(label, color) {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Chip
        label={label}
        sx={{
          ...STATUS_CHIP_STYLE,
          backgroundColor: color,
          color: "#F9FAFB",
          borderRadius: "6px",
          fontSize: "12px",
          fontWeight: 600,
          height: 28,
          px: 0.5,
          boxShadow:
            "0px 3px 3px rgba(0,14,51,0.25), 0px 1px 2px rgba(0,14,51,0.25)",
          border: "1px solid rgba(1,36,66,0.08)",
          "& .MuiChip-label": {
            px: 1,
          },
        }}
      />
    </Stack>
  );
}

export function getStatusDescribeForRecord(record) {
  if (!record) return "";

  const statusCode = String(record?.status?.code ?? "").trim();
  const statusDescribe = String(record?.status?.describe || "").trim();
  if (
    statusCode === "06" ||
    statusCode === "07" ||
    statusCode === "08" ||
    /^(entregue|finalizado|cancelado)$/i.test(statusDescribe)
  ) {
    return statusDescribe || String(record.activeStatus || "");
  }

  if (record.activeStatus) {
    const translated = translatorForTheStatusOfStoppingPoints(record.activeStatus);
    if (typeof translated === "string" && translated.trim()) {
      return translated.trim();
    }
    return String(record.activeStatus);
  }
  return statusDescribe;
}

export function formatFinancialStatusLabel(statusFinancial) {
  return formatFinancialStatusValue(statusFinancial) || "—";
}

export function getFinancialStatusForRecord(record) {
  return formatFinancialStatusLabel(record?.statusFinancial);
}

export function renderFinancialStatusColor(statusFinancial) {
  const normalized = normalizeFinancialStatusValue(statusFinancial);
  const label = formatFinancialStatusLabel(normalized);

  switch (normalized) {
    case "pendente":
      return renderStatusChip(label, "#F97316");
    case "emitido":
      return renderStatusChip(label, "#2563EB");
    case "pago":
      return renderStatusChip(label, "#059669");
    case "vencido":
      return renderStatusChip(label, "#B91C1C");
    case "cancelado":
      return renderStatusChip(label, "#6B7280");
    default:
      return renderStatusChip(label, "#64748B");
  }
}

export function renderStatusColor(status) {
  switch (status) {
    case "Contratado":
      return renderStatusChip(status, "#059669");
    case "P. Validação":
    case "Pendente de validação":
      return renderStatusChip("P. Validação", "#A855F7");
    case "P.Contratação":
    case "Pendente de contratação":
      return renderStatusChip("P.Contratação", "#F97316");
    case FREIGHT_IN_TRANSIT_DESCRIBE:
    case "Em trânsito":
      return renderStatusChip("Em trânsito", "#16A34A");
    case "Entregue":
      return renderStatusChip(status, "#2563EB");
    case "Finalizado":
      return renderStatusChip(status, "#6B7280");
    case "Cancelado":
      return renderStatusChip(status, "#B91C1C");
    default:
      return renderStatusChip(status || "—", "#64748B");
  }
}
